import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import DriverAWBTableMobile from '../../common/driver/DriverAWBTableMobile';
import DriverDOPOHeaderMobile from '../../common/driver/DriverDOPOHeaderMobile';
import DriverTruckerInfoMobile from '../../common/driver/DriverTruckerInfoMobile';
import DriverPickupFromDeliverTo from '../../common/driver/DriverPickupFromDeliverTo';
import CommonTruckerLockedContainer from '../../common/trucker/truckerLocked/CommonTruckerLockedContainer';
import DriverDODateTimeMobile from '../../common/driver/DriverDODateTimeMobile';

import PickupOrder from '../../../models/PickupOrder';

import { Moment as MomentType } from 'moment';

import style from '../../common/driver/ordersDriver.module.css';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      width: '96%',
      height: '48px',
      margin: '25px 0 0 2%',
      textTransform: 'none'
    }
  });

interface DropOffOrderDriverProps {
  classes: any;
  dropOffOrder: PickupOrder;
  dropOffTimeError: boolean;
  pickupDate: MomentType | string;
  doCheckIn: () => void;
  selectETA: () => void;
  printPickupOrder: () => void;
  dropOffTimeChange: (dateTime: MomentType) => void;
  pickupDateChange: (date: MomentType) => void;
  setContainerState: any;
};

const dropOffOrderDriver = (props: DropOffOrderDriverProps) => {

  const { classes, dropOffOrder } = props;
  
  return (
    <div className={ style.container }>

      <DriverDOPOHeaderMobile order={ dropOffOrder } type='do'/>

      <DriverDODateTimeMobile order={ dropOffOrder } pickupDate={ props.pickupDate } pickupDateChange={ props.pickupDateChange }/>
      
      <DriverPickupFromDeliverTo order={ dropOffOrder } />
      
      <DriverAWBTableMobile orderListItems={ dropOffOrder.list } />

      <DriverTruckerInfoMobile order={ dropOffOrder } />

      <CommonTruckerLockedContainer 
        dropOffOrder={ dropOffOrder } 
        sealNumberMandatory={ true } 
        setContainerState={ props.setContainerState } 
        view={ 'mobile' } 
        editable={ true } 
      />

      <div className={ style.wrapperTrcInfo }>
        <span className={ style.pot }>Additional Trucker Information:</span>
        <span className={ style.pod }>{ dropOffOrder.trucker_info }</span>
      </div>
 
      <Button
        variant="contained"
        className={ classes.button }
        color={'primary'}
        onClick={ props.selectETA }
        disabled={ !dropOffOrder.allowed_ops.update_date }
      >
        Review dock situation and select slot
      </Button>

      <Button
        disabled={ props.dropOffTimeError || !!props.dropOffOrder.driver_checkin_time  || !props.dropOffOrder.allowed_ops.driver_checked_in}
        variant="contained"
        className={ classes.button }
        color={ 'primary' }
        onClick={ props.doCheckIn }
      >
        I am on location, Check me In
      </Button>

      <Button
        variant="contained"
        className={ classes.button }
        color={ 'primary' }
        onClick={ props.printPickupOrder }
      >
        Print Drop Off Order
      </Button>
      
    </div>
  );
}

export default withStyles(styles)(dropOffOrderDriver);